import React, {useState} from "react";
import {useFormik} from "formik";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import * as Yup from "yup";
import {injectIntl} from "react-intl";
import {requestPassword} from "../../../../api/auth";
import * as actions from "../../../../store/actions/auth";
import {MDBAnimation} from "mdbreact";

const initialValues = {
    email: "",
};

const ForgotPassword = (props) => {
    const {intl} = props;
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const ForgotPasswordSchema = Yup.object().shape({
        email: Yup.string()
            .email("Wrong email format")
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const formik = useFormik({
        initialValues,
        validationSchema: ForgotPasswordSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            enableLoading();

            requestPassword(values.email)
                .then(() => {
                    setSuccess(true)
                    disableLoading();
                })
                .catch(() => {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                        intl.formatMessage(
                            {id: "AUTH.ERROR"},
                            {name: values.email}
                        )
                    );
                });
        },
    });

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    const renderSuccess = () => {
        return (
            <div className="alert alert-success">
                You will shortly receive an email with the new password if an account exists with the email you entered
            </div>
        );
    };

    return (
        <>
            <Link to="/" className="mb-15 text-center">
                <MDBAnimation type="fadeInUp">
                    <img src={'/media/logos/optimumdesk-logo.svg'} alt="Od Logo"
                         className="max-h-75px"
                         height="75"/>
                </MDBAnimation>
            </Link>

            <div className="login-form login-forgot" style={{display: "block"}}>
                <div className="text-center mb-10 mb-lg-20">
                    <h3 className="font-size-h1">Forgotten Password ?</h3>
                    <div className="text-muted font-weight-bold">
                        Enter your email to reset your password
                    </div>
                </div>

                { success && renderSuccess() }

                <form
                    onSubmit={formik.handleSubmit}
                    className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                >
                    {formik.status && (
                        <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                            <div className="alert-text font-weight-bold">
                                {formik.status}
                            </div>
                        </div>
                    )}
                    <div className="form-group fv-plugins-icon-container">
                        <input
                            placeholder="Your email address"
                            type="email"
                            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                                "email"
                            )}`}
                            name="email"
                            {...formik.getFieldProps("email")}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block">{formik.errors.email}</div>
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group d-flex flex-wrap flex-center">
                        <button
                            id="od_login_forgot_submit"
                            type="submit"
                            className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                            disabled={formik.isSubmitting}
                        >
                            Submit
                            {loading && <span className="ml-3 spinner spinner-white"></span>}
                        </button>
                        <Link to="/auth">
                            <button
                                type="button"
                                id="od_login_forgot_cancel"
                                className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                            >
                                Cancel
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        </>
    );
}

export default injectIntl(connect(null, actions)(ForgotPassword));
